module.exports = __webpack_public_path__ + "static/media/arrow-up-shadow.189982f8.png";